module.exports = __webpack_public_path__ + "a52b8c6dd634912707bdca9b14ce1574.svg";